// Служебная разметка ответов AI-ассистента (протокол задаёт сервер — ASSISTANT_UI_PROTOCOL в
// server/src/routes/chat.ts). Пользователь её не видит: сайдбар (useChatFab) вырезает
// маркеры из текста и показывает по ним прогресс и вопрос с вариантами ответа.
//   [[progress done=3 total=12 products=5]]
//   [[question]]{"text":"Какой бюджет?","options":["До 100 тыс.","Без ограничений"]}[[/question]]

export interface AssistantProgress {
  done: number | null
  total: number | null
  products: number | null
}

export interface AssistantQuestion {
  text: string
  options: string[]
}

const PROGRESS_RE = /\[\[progress\b([^\]]*)\]\]/g
const QUESTION_RE = /\[\[question\]\]([\s\S]*?)\[\[\/question\]\]/g

function parseQuestionJson(raw: string): AssistantQuestion | null {
  try {
    const data = JSON.parse(raw.trim())
    const text = typeof data?.text === 'string' ? data.text.trim() : ''
    const options = Array.isArray(data?.options)
      ? data.options.filter((o: unknown) => typeof o === 'string' && o.trim()).map((o: string) => o.trim()).slice(0, 6)
      : []
    return text ? { text, options } : null
  } catch {
    return null
  }
}

function intAttr(attrs: string, name: string): number | null {
  const m = attrs.match(new RegExp(`\\b${name}\\s*=\\s*(\\d+)`))
  return m ? Number(m[1]) : null
}

/** Последний маркер прогресса в тексте (или null, если ассистент его не выводил). */
export function parseAssistantProgress(text: string): AssistantProgress | null {
  let last: string | null = null
  for (const m of text.matchAll(PROGRESS_RE)) last = m[1] ?? ''
  if (last === null) return null
  return { done: intAttr(last, 'done'), total: intAttr(last, 'total'), products: intAttr(last, 'products') }
}

/** Вопрос с вариантами ответа — только последний и только завершённый блок. */
export function parseAssistantQuestion(text: string): AssistantQuestion | null {
  let last: AssistantQuestion | null = null
  for (const m of text.matchAll(QUESTION_RE)) last = parseQuestionJson(m[1] ?? '') ?? last
  return last
}

/**
 * Текст для показа: маркеры прогресса убраны, блок вопроса заменён самим текстом вопроса,
 * недописанный маркер в конце потока ("[[progr…", "[[question]]{…") спрятан до завершения.
 */
export function stripAssistantMarkup(text: string): string {
  let out = text
    .replace(QUESTION_RE, (_m, raw: string) => parseQuestionJson(raw)?.text ?? '')
    .replace(PROGRESS_RE, '')
  const open = out.lastIndexOf('[[')
  if (open !== -1 && !out.slice(open).includes(']]')) out = out.slice(0, open)
  const openQuestion = out.lastIndexOf('[[question]]')
  if (openQuestion !== -1) out = out.slice(0, openQuestion)
  return out.replace(/\n{3,}/g, '\n\n').trim()
}
